import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { Loader2 } from 'lucide-react';
import { TOKEN_KEY, REFRESH_KEY } from '@/lib/api';

/**
 * Handles OAuth redirect callbacks (Google, etc.).
 * Tokens are passed in the URL hash fragment: #access_token=...&refresh_token=...&provider=...
 */
export default function OAuthCallbackPage() {
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    const hash = window.location.hash.substring(1);
    const params = new URLSearchParams(hash);

    const accessToken = params.get('access_token');
    const refreshToken = params.get('refresh_token');

    if (accessToken && refreshToken) {
      localStorage.setItem(TOKEN_KEY, accessToken);
      localStorage.setItem(REFRESH_KEY, refreshToken);
      // Full page load so AuthProvider picks up the new tokens
      window.location.href = '/dashboard';
    } else {
      setError('Sign-in failed. Please try again.');
      setTimeout(() => navigate('/login', { replace: true }), 3000);
    }
  }, [navigate]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center p-6">
        <div className="text-center">
          <p className="text-sm text-red font-semibold mb-2">{error}</p>
          <p className="text-xs text-ink-3">Redirecting to sign in...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="text-center">
        <Loader2 size={32} className="text-orange animate-spin mx-auto mb-4" />
        <p className="text-sm text-ink-3">Signing you in...</p>
      </div>
    </div>
  );
}
